/* Site-wide chrome (batch 1, 2026-10-10): header behaviours from homepage v2, on every page. No network calls.
   Mobile search placeholder (480px and below), "/" focuses the header search, the header menu button opens the category drawer. */
(function () {
  'use strict';
  if (window.EcomChrome) return;
  var VERSION = '2026-10-10-sw1';
  function q(s, r) { return (r || document).querySelector(s); }
  function initPlaceholder() {
    var i = q('#ecom-header-search-input'); if (!i || !i.dataset.hv2PhMobile || i.dataset.hv2PhDesk) return;
    i.dataset.hv2PhDesk = i.getAttribute('placeholder') || '';
    var mq = window.matchMedia('(max-width: 480px)');
    function set() { i.setAttribute('placeholder', mq.matches ? i.dataset.hv2PhMobile : i.dataset.hv2PhDesk); }
    set(); if (mq.addEventListener) mq.addEventListener('change', set); else if (mq.addListener) mq.addListener(set);
  }
  function initSlash() {
    document.addEventListener('keydown', function (e) {
      if (e.key !== '/' || e.ctrlKey || e.metaKey || e.altKey) return;
      var a = document.activeElement, tag = a && a.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || (a && a.isContentEditable)) return;
      var i = document.getElementById('ecom-header-search-input'); if (!i) return;
      e.preventDefault(); i.focus();
    });
  }
  function initMenu() {
    var b = q('[data-hv2-menu]'); if (!b) return;
    b.addEventListener('click', function () { var t = document.getElementById('mega-mobile-toggle'); if (t) t.click(); });
  }
  // The header has two cart counts (desktop "Cart N" + mobile badge) that share id="cart-count-header"; the theme's cart code
  // updates only the first, so the mobile badge stayed at the page-load count after Add (pre-existing). Mirror the first into the rest.
  function initCount() {
    var all = document.querySelectorAll('#cart-count-header'); if (all.length < 2 || !window.MutationObserver) return;
    var src = all[0];
    function sync() { var v = src.textContent; for (var i = 1; i < all.length; i++) if (all[i].textContent !== v) all[i].textContent = v; }
    new MutationObserver(sync).observe(src, { childList: true, characterData: true, subtree: true }); sync();
  }
  function init() { initPlaceholder(); initSlash(); initMenu(); initCount(); }
  window.EcomChrome = { version: VERSION };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
